// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'service.page.title': 'Services',
    'service-csv.page.import.title': 'Import Services',
    'service.page.search_results': 'Search Results',
    'service.page.create.title': 'Create New Service',
    'service.page.search.title': 'Find Services',
    'service.page.edit.title': 'Edit Service',
    'service.page.all': 'All',

    'service.button.cancel': 'Cancel',
    'service.button.select': 'Select',
    'service.button.find': 'Find Services',
    'service.button.search': 'Apply',
    'service.button.create': 'Save Service',
    'service.button.new': 'New Service',
    'service-csv.button.import': 'Import',
    'service.button.save': 'Save Changes',
    'service.button.delete': 'Permanently Delete',
    'service.button.edit': 'Edit',
    'service.button.restore': 'Restore',
    'service.button.reset': 'Reset',
    'service-csv-import.button.download': 'Download sample file',

    'service.placeholder.search': 'Search services',

    'service.link.create_first_service': 'Click here to create your first service',
    'service.link.services': ' Return to Services',
    'service.link.retry': 'Click here to retry',

    'service.checkbox.all': 'Check All',
    'service.checkbox.actions_label': 'with selected',

    'service.label.inventory_category_name': 'Category',

    'service.label.inventory_manufacturer_name': 'Manufacturer',

    'service.label.reporting_segment_name': 'Reporting Segment',

    'service.label.inventory_type_name': 'Type',

    'service.label.is_manufactured': 'Is Manufactured',

    'service.label.is_combinable': 'Is Combinable',

    'service.label.combinable_parent_inventory_name': 'Combinable Parent Service',

    'service.label.from__breakdown_pieces': 'From breakdown pieces',
    'service.label.to__breakdown_pieces': 'To breakdown pieces',
    'service.label.breakdown_pieces': 'Breakdown Pieces',

    'service.label.income_general_ledger_account_name': 'Income General Ledger Account',

    'service.label.cost_of_good_sold_general_ledger_account_name': 'Cost Of Good Sold General Ledger Account',

    'service.label.asset_general_ledger_account_name': 'Asset General Ledger Account',

    'service.label.tax_name': 'Tax',

    'service.label.item_number': 'Item Number',

    'service.label.barcode': 'Barcode',

    'service.label.item_name': 'Item Name',

    'service.label.item_description': 'Item Description',

    'service.label.currency_name': 'Currency',

    'service.label.is_fixed_price': 'Is Fixed Price',

    'service.label.from__selling_price_in_cents': 'From selling price',
    'service.label.to__selling_price_in_cents': 'To selling price',
    'service.label.selling_price_in_cents': 'Selling Price',

    'service.label.from__reorder_level': 'From reorder level',
    'service.label.to__reorder_level': 'To reorder level',
    'service.label.reorder_level': 'Reorder Level',

    'service.label.from__units_on_hand': 'From units on hand',
    'service.label.to__units_on_hand': 'To units on hand',
    'service.label.units_on_hand': 'Units On Hand',

    'service.label.item_photo': 'Item Photo',

    'service.label.from__item_photo_size': 'From item photo size',
    'service.label.to__item_photo_size': 'To item photo size',
    'service.label.item_photo_size': 'Item Photo Size',

    'service.label.item_photo_mime_type': 'Item Photo Mime Type',

    'service.label.from__created_at': 'From created at',
    'service.label.to__created_at': 'To created at',
    'service.label.created_at': 'Created At',

    'service.label.from__updated_at': 'From updated at',
    'service.label.to__updated_at': 'To updated at',
    'service.label.updated_at': 'Updated At',

    'service.label.from__deleted_at': 'From deleted at',
    'service.label.to__deleted_at': 'To deleted at',
    'service.label.deleted_at': 'Deleted At',

    'service.label.attributes': 'Attributes',
    'service.label.additional_taxes': 'Additional Taxes',
    'service.label.status': 'Status',

    'service.sort.field_label': 'Field',
    'service.sort.direction_label': 'Direction',
    'service.sort.direction_ascending': 'Ascending',
    'service.sort.direction_descending': 'Descending',

    'service.modal.title.service_delete_permanently': 'Delete Service',
    'service.modal.title.service_restore': 'Restore Service',

    'service.modal.message.service_delete_permanently':
        'Are you sure that you want to permanently delete this service? This action cannot be undone. | Are you sure that you want to permanently delete these services? This action cannot be undone.',
    'service.modal.message.service_restore': 'Are you sure that you want to restore this service? | Are you sure that you want to restore these services?',

    'service.success.message.service_created': 'Your service has been created',
    'service.success.message.service_updated': 'Your service has been updated',
    'service.success.message.service_restored': 'Your service has been restored | All selected services were restored',
    'service.success.message.service_deleted': 'Your service has been permanently deleted | All selected services were permanently deleted',

    'service.error.message.service_deleted': 'This service was already permanently deleted | These services were already permanently deleted',
    'service.error.message.service_restored': 'This service was already restored | These services were already restored',
    'service.error.message.error_loading_page': 'Sorry, there was an error loading service.| Sorry, there was an error loading services.',
    'service-csv.error.message.csv_is_blank': "It looks like the CSV file is empty. No worries — just take a moment to double-check your file, and feel free to try again whenever you're ready!",
    'service-csv.error.message.invalid_file_type': 'Sorry, we only support CSV files. Please try again with a CSV file.',

    'service-csv.page.note': 'Please ensure to click the check mark if your file already includes headers.',
    'service.success.message.services_imported': 'Please check your email for the import status.',
    'service-csv.page.instructions': 'Below are two sample files which will show the fields used in the import process.',

    'service-csv.page.required_fields': 'Required Fields',
    'service-csv.page.all_fields': 'All Fields',
    'service-import.button.download': 'Download sample file',

    'service-csv.page.message.column_names': 'Column names are in the first line',
    'service-csv.page.message.field': 'Field',
    'service-csv.page.message.column': 'Column',

    'service.page.archive.title': 'Archived Services',

    'service.button.archive': 'Archive',

    'service.link.archive': 'Archived Services',

    'service.modal.title.service_archive': 'Archive Service',

    'service.modal.message.service_archive': 'Are you sure that you want to move this service to the archive? | Are you sure that you want to move these services to the archive?',

    'service.success.message.archived_services': 'Your service was moved to the archive | All selected services were moved to the archive',

    'service.error.message.archived_services': 'This service was already moved to the archive | These services were already moved to the archive',

    'service.message.search.no_archived_services': "You don't have any archived services.",
};
